import CircleHelp from '../../../assets/icons/Circle_Help.svg';

export function DefaultTerm({ goal, styles }) {
  const isAutoInfo = goal.leftText === 'Считается по доходам за текущий месяц';
  if (!goal.deadlineText && !goal.leftText) return null;

  return (
    <div className={styles.goalTerm}>
      {goal.deadlineText ? <h4 className={styles.goalTerm__deadline}>{goal.deadlineText}</h4> : null}

      {goal.leftText ? (
        isAutoInfo ? (
          <div className={styles.goalTerm__info}>
            <img src={CircleHelp} className={styles.goalTerm__infoIcon} aria-hidden />
            <p className={styles.goalTerm__infoText}>{goal.leftText}</p>
          </div>
        ) : (
          <p className={styles.goalTerm__left}>{goal.leftText}</p>
        )
      ) : null}
    </div>
  );
}